import { useSelector } from 'react-redux';

import { selectExpirationDate } from '../store/slices/initialSlice';
import { useTranslate } from './useTranslate';

const MS_IN_HOUR = 3600000;

const MONTHS = {
  0: 'monthJanuary',
  1: 'monthFebruary',
  2: 'monthMarch',
  3: 'monthApril',
  4: 'monthMay',
  5: 'monthJune',
  6: 'monthJuly',
  7: 'monthAugust',
  8: 'monthSeptember',
  9: 'monthOctober',
  10: 'monthNovember',
  11: 'monthDecember',
};

interface StorageDate {
  expDate: string;
  diffHours: number;
}

export function useStorageDate(): StorageDate {
  const expirationDateUnix = useSelector(selectExpirationDate);
  const { staticTranslate } = useTranslate();

  const expirationDate = new Date(expirationDateUnix);
  const now = Date.now();

  const expDay = expirationDate.getDate();
  const expMonth = MONTHS[expirationDate.getMonth() as keyof typeof MONTHS];
  const expYear = expirationDate.getFullYear();

  const diffHours = (expirationDateUnix - now) / MS_IN_HOUR;

  const expDate = `${expDay} ${staticTranslate(expMonth)} ${expYear}`;

  return {
    expDate,
    diffHours,
  };
}
